/** 外科 */

/** 对应的标题 */
const categoryMap = {
  OvarianCancer_TNM: '卵巢癌TNM分期',
  ProstateCancer_TNM: '前列腺癌TNM分期',
  BI_RADS: '乳腺影像报告数据系统（BI-RADS）',
}
/** 对应的描述 */
const categoryDescMap = {
  OvarianCancer_TNM: '评估卵巢癌患者进展',
  ProstateCancer_TNM: '评估前列腺癌患者病情进展',
  BI_RADS: '',
}
export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/DS.js